import http from '../http'

/** 登录 */
// 获取验证码
export function GetLoginVerify(params) {
    return http.get('/user/code', params)
}
// 登录
export function Login(params) { 
    return http.post('/user/login', params, { "Client-Type": "web" })
}
// 获取消息
export function GetMessageList(params) { 
    return http.get('/sys/message/list', params)
}
// 获取消息后传递数据到服务器
export function PushMessagePara(params) {
    return http.get('/sys/message/msgTime', params)
}

/** 上传文件接口 */
export function UploadFile(params) {
    return http.post('/common/upload', params, {"Content-Type": "multipart/form-data"})
}

/** 监督方-地图视图 */
// 获取钻探位置
export function GetDrillLocationList(params) {
    return http.get('/sys/zkdata/mapList', params)
}
// 获取钻孔信息
export function GetDrillDetailInfo(params) {
    return http.get('/sys/zkdata/singleZKInfo', params)
}
// 获取外业施工人员位置
export function GetWorkerLocation(params) {
    return http.get('/sys/dept/xgdLocation', params)
}

/** 监督方-施工单位管理 */
// 获取地震局
export function GetEarthquakeUnit(params) {
    return http.get('/sys/user/dzu', params)
}
// 创建施工单位
export function CreateUnit(params) {
    return http.post('/sys/dept/create', params)
}
// 重置施工单位密码
export function ResetUnitPassword(params) {
    return http.post('/sys/dept/resetpwd', params)
}
// 获取施工单位列表 
export function GetUnitList(params) {
    return http.get('/sys/dept/deptlist', params)
}
// 删除施工单位列表 
export function DeleteUnitList(params) {
    return http.post('/sys/dept/delete', params)
}
// 更新施工单位列表 
export function UpdateUnitList(params) {
    return http.post('/sys/dept/update', params)
}
// 导入钻孔数据
export function ImportDrillData(params) {
    return http.post('/sys/zkdata/import', params)
}
// 获取钻孔列表
export function GetDrillDataList(params) {
    return http.get('/sys/zkdata/page', params)
}
// 批量删除钻孔 
export function DeleteBatchDrill(params) {
    return http.post('/sys/zkdata/deleteBatch', params)
}

/** 施工队管理 */
// 获取施工单位信息
export function GetConstructionInfo(params) { 
    return http.get('/sys/dept/xgdw', params)
}
// 给施工队添加任务
export function ConstructionAddTask(params) {
    return http.post('/sys/zkdata/allot', params)
}

/** 勘察报告 */ 
// 获取已完成钻孔列表
export function GetCompleteDrillList(params) {
    return http.get('/sys/zkdata/docPage', params)
}
// 提交勘察报告
export function ConstructionSubmitReport(params) {
    return http.post('/sys/zkdata/uploadDoc', params, {"Content-Type": "multipart/form-data"})
}
// 删除报告
export function DeleteDrillReport(params) {
    return http.post('/sys/zkdata/deleteDoc', params)
}

/** 日志 */
// 获取日志列表
export function GetLogList(params) {
    return http.get('/sys/log/page', params)
}
// 导出日志 
export function ExportLogList(params) {
    return http.get('/sys/log/export', params)
}


// 导出日志 
export function ExportZkDataList(params) {
    return http.get('/sys/zkdata/export', params)
}

// 创建施工队
// export function CreateConsTeam(params) {
//     return http.post('/sys/dept/update', params)
// }